import { apiGet } from '../lib/api'

export const CHECK_FILE_SUCCESS = 'CHECK_FILE_SUCCESS'
export const CHECK_ZIP_FILE_SUCCESS = 'CHECK_ZIP_FILE_SUCCESS'
export const CLEAR_DOWNLOAD = 'CLEAR_DOWNLOAD'
export const CLEAR_ZIP_DOWNLOAD = 'CLEAR_ZIP_DOWNLOAD'

export const checkFile = (filename) => ({ getState, fetch }) => ({
  type: 'CHECK_FILE',
  payload: apiGet({
    fetch,
    endpoint: `downloads/${filename}`,
    getState,
  }),
})

export const checkZipFile = (filename) => ({ getState, fetch }) => ({
  type: 'CHECK_ZIP_FILE',
  payload: apiGet({
    fetch,
    endpoint: `downloads/${filename}`,
    getState,
  }),
})

export const clearDownload = () => ({
  type: 'CLEAR_DOWNLOAD',
  payload: {},
})

export const clearZipDownload = () => ({
  type: 'CLEAR_ZIP_DOWNLOAD',
  payload: {},
})



// WEBPACK FOOTER //
// ./src/common/downloads/actions.js